import {
  USERS_PREPTALK_RESET,
  USERS_PREPTALK_LOAD_COACHES_REQUEST, USERS_PREPTALK_LOAD_COACHES_SUCCESS, USERS_PREPTALK_LOAD_COACHES_FAILURE,
  USERS_PREPTALK_LOAD_STUDENTS_REQUEST, USERS_PREPTALK_LOAD_STUDENTS_SUCCESS, USERS_PREPTALK_LOAD_STUDENTS_FAILURE,
} from "./UsersPrepTalkTypes";

const initial = {
  coaches: [], students: [],
  loadingCoaches: false, loadingStudents: false,
  hasMoreCoaches: true, hasMoreStudents: true,
  cursorCoaches: null, cursorStudents: null,
  error: null,
};

export const usersPreptalkReducer = (state = initial, action) => {
  switch (action.type) {
    case USERS_PREPTALK_RESET: return { ...initial };
    case USERS_PREPTALK_LOAD_COACHES_REQUEST: return { ...state, loadingCoaches: true, error: null, ...(action.payload?.reset ? { coaches: [], cursorCoaches: null, hasMoreCoaches: true } : {}) };
    case USERS_PREPTALK_LOAD_COACHES_SUCCESS: {
      const { items, last, hasMore, reset } = action.payload;
      return { ...state, loadingCoaches: false, coaches: reset ? items : [...state.coaches, ...items], cursorCoaches: last, hasMoreCoaches: hasMore };
    }
    case USERS_PREPTALK_LOAD_COACHES_FAILURE: return { ...state, loadingCoaches: false, error: action.payload };
    case USERS_PREPTALK_LOAD_STUDENTS_REQUEST: return { ...state, loadingStudents: true, error: null, ...(action.payload?.reset ? { students: [], cursorStudents: null, hasMoreStudents: true } : {}) };
    case USERS_PREPTALK_LOAD_STUDENTS_SUCCESS: {
      const { items, last, hasMore, reset } = action.payload;
      return { ...state, loadingStudents: false, students: reset ? items : [...state.students, ...items], cursorStudents: last, hasMoreStudents: hasMore };
    }
    case USERS_PREPTALK_LOAD_STUDENTS_FAILURE: return { ...state, loadingStudents: false, error: action.payload };
    default: return state;
  }
};
